import { UIBreakpoint } from "@shared/constaints/ui/types";

export const breakpoints = {
  xs: 375,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1920
};

export const breakpointKeys = ['base', ...Object.keys(breakpoints)] as UIBreakpoint[];